import { CartModule } from "./cart/module";
const ShoppingCart = new CartModule();
export default ShoppingCart;
